// Game start date - February 2, 2022
export const GAME_EPOCH = new Date("February 2, 2022 00:00:00").valueOf();
export const MS_IN_DAY = 86400000;
